import { Map } from 'immutable';
import { actionTypes as CreateDeviceAppDialogActionsType } from '../../../actions/Administration/RfidSettingsPage/Dialogs/createDeviceAppDialogActions.js';

let defaultState = {
  show: false,
  loading: false,
  itemToEdit: null,
  dialogData: null,
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case CreateDeviceAppDialogActionsType.CREATE_DEVICE_APP_DIALOG_SHOW:
      state = state.set('itemToEdit', action.payload);
      return state.set('show',true);

    case CreateDeviceAppDialogActionsType.CREATE_DEVICE_APP_DIALOG_HIDE:
      return Map(defaultState);

    case CreateDeviceAppDialogActionsType.CREATE_DEVICE_APP_DIALOG_SUBMIT_IN_PROGRESS:
      return state.set("loading", true);

    case CreateDeviceAppDialogActionsType.CREATE_DEVICE_APP_DIALOG_SUBMIT_FINISHED:
      return state.set("loading", false);

    case CreateDeviceAppDialogActionsType.CREATE_DEVICE_APP_DIALOG_FETCH_DATA_READY:
      return state.set("dialogData", action.payload);

    default:
      return state;
  }

}







